import script from "./ShareModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareModal.vue?vue&type=style&index=0&id=245f9be0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245f9be0"]])

export default __exports__